import type { PropsWithChildren, ReactNode } from 'react';

import './variant-fieldset.scss';

type VariantFieldsetProps = PropsWithChildren & {
    legendKey: string;
    legendValue: string;
    legendAction?: ReactNode;
};

export const VariantFieldset = ({ legendKey, legendValue, legendAction, children }: VariantFieldsetProps) => {
    return (
        <fieldset className="variants-fieldset" data-testid={legendKey}>
            <legend className="variants-fieldset__legend">
                <span className="variants-fieldset__legend-key">{legendKey}:</span>
                <span className="variants-fieldset__legend-value">{legendValue}</span>
                {legendAction && <div className="variants-fieldset__legend-action">{legendAction}</div>}
            </legend>
            {children}
        </fieldset>
    );
};
